import { createFileRoute } from '@tanstack/react-router';
import { ProfilePage } from '../pages/ProfilePage';
import { ProtectedRoute } from '../../../shared/ui';

const ProtectedProfilePage = () => (
  <ProtectedRoute>
    <ProfilePage />
  </ProtectedRoute>
);

export const Route = createFileRoute('/profile')({
  component: ProtectedProfilePage,
});
